export enum EnumEmployeeCard {
    ADAPTATION = 'adapdation',
    ADDRESS = 'address',
    ATTACHMENT = 'attachment',
    AWARD = 'award',
    BANK = 'bank',
    CERTIFICATE = 'certificate',
    COMPENSATION = 'compensation',
    CONTRACT = 'contract',
    COURT = 'court',
    CREDIBLE_EXPERIENCE = 'credible-experience',
    DECLARATION_GOODS = 'declaration-goods',
    DEGREE = 'degree',
    DISABILITY = 'disability',
    EDUCATION = 'education',
    EXAM = 'exam',
    EXPERIENCE = 'experience',
    EXPERIENCE_MERGE = 'experience-merge',
    EXTERNAL = 'external',
    FAMILY = 'family',
    HEALTH = 'health',
    IDENTIFICATION = 'identification',
    IDENTITY = 'identity',
    MILITARY = 'military',
    PERSONNEL_ORGANIZATION = 'personnel-organization',
    PER_FOREIGN_LANGUAGE = 'per-foreign-language',
    PHYSICAL_STANDARD = 'physical-standard',
    PUNISHMENT = 'punishment',
    SYNDICATE = 'syndicate',
    TELEPHONE = 'telephone',
    WEAPON = 'weapon',
    VEHICLE = 'vehicle',
    HISTORICAL_DATA = 'historical-data',
    SPECIAL_SITUATION = 'special-situation',
    BORROWING = 'borrowing',
    SUSPENSION_TIME = 'suspension-time',
    MOVEMENT = 'movement',
    MOVEMENT_PRIVATE = 'movement-private',
    MOVEMENT_INFO = 'movement-info',
    EXCEPTIONAL_RELATION = 'exceptional-relation',
    ACCIDENT = 'accident',
    TRIP = 'trip',
    SECONDMENT = 'secondment',
    TERMINATION = 'termination',
    SECONDMENT_APPROVEMENT = 'secondment_approvement',
    BASIS_INFO = 'personnel_basis_info_page',
    BASIS_OFFICER_INFO = 'personnel_officer_basis_info_page',
    ABSENCE_ENTRY = 'absence-entry',
    OVERTIME = 'overtime',
    PAYROLL_INFO = 'payroll-info',
    PERSONNEL_S_I_DEDUCTION_LAW = 'personnel-s-i-deduction-law',
    EXPENSE_CENTER = 'expense_center',
    EXPENSE_CENTER_DETAIL = 'expense_center_detail',
    COMMON_PAYMENT = 'common-payment',
    ADDITIONAL_PAYMENT = 'additional-payment',
    DEDUCATION = 'deduction',
    INDIVIDUAL_PAYMENT = 'individual-payment',
    ABSENCE_QUOTA = 'absence-quota',
    ATTENDANCE_MASTER = 'attendance-master',
    WORK_SCHEDULE = 'work-schedule',
    TM_PROJECT_INFO = 'tm-project-info',
    PASSPORT_VISA_INFO = 'passport-visa-info',
    PASSPORT_DEMAND = 'passport-demand',
    WORK_CERTIFICATE_DEMAND = 'work-certificate-demand',
    CONFIRMATION_OF_NOBILITY = 'confirmation-of-nobility',
    EXPERIENCE_HISTORY = 'experience-history',
    PASSPORT = 'passport',
    INSURANCE_INFO = 'per-ins-policy-info',
    PER_SSI_OFF_SETTING = 'per-ssi-off-setting',
    PER_CAREER_PATH_INFO = 'per-career-path-info',
    PER_ASSETS="per-assets",
    FINANCIAL_ACTIVITIES = 'per-financial-activities',
}
